// COHESION CONSTANTS
export const WRITE_KEY =
  process.env.environment === "production"
    ? "wk_1NT299B6zAqwtypc6ULw3pZ3vyJ"
    : "wk_24yH5wA4KRm7uk2m6DWo37rMSik";
export const SOURCE_KEY =
  process.env.environment === "production"
    ? "src_1NT299Hykp1EOgLj96gZgh2RX5P"
    : "src_24yH5vGUPks7O2KRIGUNCHZrR19";

export const DEFAULT_FUSE_NUMBER = "8664994271";

export const MONARCH_SOURCE = "088adec0-65af-49ae-98b3-337ab58d4f6b";
export const MONARCH_TOKEN = "e9584f8a-2739-486b-a11e-2b176f158cd2";
